import { ReactComponent as PlusIcon } from "assets/icons/plus.svg";
import Button from "components/button/Button";
import { SubHeader } from "layout/SubHeader";
import React from 'react';

const EasyCareHeader = ({setNewTaskDrawer,setNewEventDrawer,activeTab}) => {
  return (
    <div 
      className="d-flex justify-content-between align-items-center subHeader" 
      style={{
        minHeight: 48,
      }}
    >
    <div className="">
      <SubHeader
          className="subheader"
          {...{
            title: "Easycare",
            color: "#2455EF",
          }}
        />
    </div>
    {activeTab === "dashboard" && (
      <div className="d-flex memberBtn pastoral__header-buttons">
        <Button
            variant="primary-outline"
            onClick={() => setNewTaskDrawer(true)}
            style={{ marginLeft: 10}}
          >
            <PlusIcon fill="#2555ef" />
            <span>New Task</span>
        </Button>
        <Button
            variant="primary"
            onClick={() => setNewEventDrawer(true)}
            style={{ marginLeft: 10}}
          >
            <PlusIcon />
            <span>New Event</span>
        </Button>
      </div>
    )}
  </div>
  )
}

export default EasyCareHeader